import { render } from "./StockPage.vue?vue&type=template&id=5af49ef5&scoped=true"
import script from "./StockPage.vue?vue&type=script&lang=js"
export * from "./StockPage.vue?vue&type=script&lang=js"

import "@/css/StockPage.css?vue&type=style&index=0&id=5af49ef5&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af49ef5"]])

export default __exports__